<template lang="pug">
v-card.mx-auto.elevation-0
  //- v-img(height='250' v-if="datos.marca.urlImage" :src="datos.marca.urlImage")
  v-list(dense)
    v-list-item(two-line='')
      v-list-item-content
        v-list-item-title.font-weight-700.font-size-16 {{datos.nombreArticulo}}
        v-list-item-subtitle.font-size-12 {{datos.codigoArticulo}} - {{datos.modelo}} - {{datos.linea}}
  v-divider.mx-4
  v-card-text
   v-list( dense)
    v-list-item.py-1(v-if="showImageMarca")
      v-list-item-content
        v-img( :src="`${apiUpload}/upload/octopus/marcas/${datos.marca}.jpg`", width="90", height="90" contain)
    v-list-item
      v-list-item-icon
        v-icon(color='primary')
          | circle
      v-list-item-content
        v-list-item-subtitle Codigo nuevo articulo
        v-list-item-title.font-weight-700(:class="{'error--text' : !datos.codigoArticuloNuevo}") {{datos.codigoArticuloNuevo ? datos.codigoArticuloNuevo : 'No se cuenta con codigo nuevo'}}
    v-list-item
      v-list-item-icon
        v-icon(color='primary')
          | business
      v-list-item-content
        v-list-item-subtitle Cliente
        v-list-item-title.font-weight-700 {{datos.nombreCliente}} - {{datos.codigoClienteSap}}
    v-list-item
      v-list-item-icon
        v-icon(color='primary')
          | place
      v-list-item-content
        v-list-item-subtitle Direccion
        v-list-item-title.font-weight-700 {{datos.direccion}} -  {{datos.codigoPostal}}
    v-list-item
      v-list-item-icon
        v-icon(color='primary')
          | description
      v-list-item-content
        v-list-item-subtitle  Fatura electronica
        v-list-item-title.font-weight-700(:class="{'error--text' : !datos.factura}") {{datos.factura ? datos.factura : 'No se encontró ninguna factura o boleta'}}
    v-list-item
      v-list-item-icon
        v-icon(color='primary')
          | event_available
      v-list-item-content
        v-list-item-subtitle  Fecha de venta
        v-list-item-title.font-weight-700(:class="{'error--text' : !datos.fechaVenta}") {{datos.fechaVenta ? datos.fechaVenta : 'No se especifico'}}

  v-card-actions.pa-4
    v-btn(color='primary' small block @click="close()")
      | Cerrar ventana
</template>
<script>
import { apiGet, notify } from '../util/general'
export default {
  props : {
    serie : {
      type   : String,
      default: ''
    },
    tipoTicket : {
      type   : String,
      default: 0
    }
  },
  data () {
    return {
      isLoading     : false,
      isLoadingImage: false,
      datos         : {},
      marcas        : [],
      apiUpload     : process.env.API_UPLOAD_ROUTE,
      showImageMarca: false
    }
  },
  created () {
    var vm = this
    if (!vm.serie) {
      notify(vm, 'error', 'Error', 'Ingrese una serie valida')
      vm.$emit('close')
      return;
    } else vm.fetch()
  },
  methods : {
    fetchGetDataMarcas () {
      var vm  = this
      vm.showImageMarca = false
      var obj = {
        octopus: true
      }
      apiGet(vm, '/articulo/marca-articulo', obj, function (data) {
        vm.marcas = data.lista
        var iniciales      = vm.datos.codigoArticuloNuevo.substring(3, 5)
        var datosMarca    = vm.marcas.find(e => e.codigo === iniciales)
        vm.datos.marca = datosMarca.descripcion
        vm.datos.codigoMarca = datosMarca.codigo
        vm.showImageMarca = true
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      })
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo información de la serie' })
      var obj = {
        serie: vm.serie,
        tipoTicket : vm.tipoTicket
      }
      apiGet(vm, '/integracion/serie/obtener', obj, function (data) {
        console.log('data', data.data[0])
        vm.datos = data.data
        if (vm.datos.codigoArticuloNuevo) {
          vm.fetchGetDataMarcas()
        }
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
        vm.$emit('close')
      }, () => {
        vm.isLoading = false
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    close () {
      var vm = this
      vm.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// c_card_informacion_serie.vue?6f91f8b8